import React, { useContext, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useCreateCorrection } from '../../hooks/useCreateCorrection';
import Tags from '../../common/Tags';
import { AppContext } from '../../../App';

interface CorrectionFieldTagsProps {
  extractionId?: string;
  fieldContent?: string;
  fieldLabel: string;
  fieldTags: string[];
  isReadOnly?: boolean;
}

const CorrectionFieldTags: React.FC<CorrectionFieldTagsProps> = ({
  extractionId,
  fieldContent,
  fieldLabel,
  fieldTags,
  isReadOnly,
}) => {
  const { setToast } = useContext(AppContext);
  const [tags, setTags] = useState(fieldTags);
  const cache = useQueryClient();

  const { mutate: createCorrection } = useCreateCorrection(true, true);

  const updateTags = (newTags: string[], tag: string, action: 'addition' | 'removal') => {
    const content = fieldContent; // Content is required for correction
    const tokens: any = [];
    const newCorrection = { content, tokens };

    createCorrection(
      {
        extraction: extractionId,
        field: fieldLabel,
        correction: newCorrection,
        glynt_tags: newTags,
      },
      {
        onSuccess: () => {
          setTags(newTags);
          cache.invalidateQueries({
            queryKey: ['extraction']
          });
        },
        onError: (error: any) => {
          console.error('ERROR', error);
          setToast({
            open: true,
            message: `Error during tag ${action}: ${
              error?.message || 'Error during correction update'
            }`,
            variant: 'error',
          });
        },
      }
    );
  };

  const addTag = (tag: string) => {
    const newTags = [...tags, tag];
    updateTags(newTags, tag, 'addition');
  };

  const removeTag = (tag: string) => {
    const updatedTags = tags.filter((t) => t !== tag);
    updateTags(updatedTags, tag, 'removal');
  };

  return (
    <Tags
      domId={`${fieldLabel}-new-glynt-tag`}
      cypressId={`${fieldLabel}-new-glynt-tag`}
      tags={tags}
      addTag={addTag}
      removeTag={removeTag}
      variant={'outlined'}
      placeholder={'New Tag'}
      color={'primary'}
      isReadOnly={isReadOnly}
    />
  );
};

export default CorrectionFieldTags;
